import React from 'react';
import { Typography } from '@mui/material';

const RecentRaces: React.FC = () => (
  <div>
    <Typography variant="h4" gutterBottom>
      Recent Races
    </Typography>
    {/* Recent races list will go here */}
  </div>
);

export default RecentRaces; 